/** Choices for policy reporting cadence inputs, shared by the create form, the
 *  detail-page dialog, and the inline overview grid so they stay consistent. */

export const CADENCE_CHOICES = [
  { id: "monthly", name: "Monthly" },
  { id: "weekly", name: "Weekly" },
];

/**
 * Day-of-week choices. Values are ISO 8601 (1 = Monday … 7 = Sunday), matching
 * the backend `reporting_day_of_week` column and validation. Labelled so users
 * pick a day name rather than a bare 1–7 number.
 */
export const WEEKDAY_CHOICES = [
  { id: 1, name: "Monday" },
  { id: 2, name: "Tuesday" },
  { id: 3, name: "Wednesday" },
  { id: 4, name: "Thursday" },
  { id: 5, name: "Friday" },
  { id: 6, name: "Saturday" },
  { id: 7, name: "Sunday" },
];

/** Returns an ordinal label for a day number, e.g. 1 -> "1st", 22 -> "22nd". */
const ordinal = (n: number): string => {
  const suffixes = ["th", "st", "nd", "rd"];
  const mod100 = n % 100;
  return `${n}${suffixes[(mod100 - 20) % 10] ?? suffixes[mod100] ?? suffixes[0]}`;
};

/**
 * Day-of-month choices, 1st–28th. Capped at 28 (matching the backend
 * `reporting_day_of_month` 1–28 constraint) to avoid month-end ambiguity.
 */
export const MONTH_DAY_CHOICES = Array.from({ length: 28 }, (_, i) => ({
  id: i + 1,
  name: ordinal(i + 1),
}));
